<template>
    <div class="news">
       <div class="newsBanner">
        <img src="../../assets/product/product-banner.png" alt="">
       </div>
       <div class="newsCenter">
        <div class="search">
            <div class="searchBox">
                <input type="text" v-model="name" placeholder="输入搜索信息">
                <button @click="getProducts">搜索</button>
            </div>
        </div>
         <div class="newsTab">
            <div class="newsTab_top">
                <ul>
                  <li v-for="(item,index) in proCate" :key="index" @click="handleChangeCate(item.id)" :class="{new_active:curCate==item.id}">
                    {{ item.name }}</li>
                </ul>
            </div>
              <div >
                <div class="newsTab_center">
                    <div class="pro_item" v-for="item in proList" :key="item.id" >
                        <div @click="$router.push( {path:'/productDetail',query:{id:item.id}})">
                        <div class="pro-img"><img :src="item.coverUrl" alt=""></div>
                        <p class="pro_detail">{{item.title}}</p>
                        </div>
                    </div>
                </div>

                <!-- 分页 -->
                <div class="paginationMy">
                  <el-pagination
                      background
                      @size-change="handleSizeChange"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      layout="total, prev, pager, next, jumper"
                      :total="total">
                  </el-pagination>
                </div>
              </div>
         </div>
       </div>
    </div>
</template>

<script>
import request from "@/util/request";
export default {
  data(){
    return {
      proCate:[],
      contentType:2,
      name:null,
      currentPage: 1,
      pageSize: 12,
      total: 100,
      curCate:this.$route.query.cateId,
      proList:[],
    }

  },
  mounted() {
    if(this.curCate){
    this.getProducts()
    }
    this.getCataLog()

  },
  watch: {
    '$route.query.cateId'(){
      this.curCate = this.$route.query.cateId
      this.getProducts()
    }
  },
  methods:{
    handleSizeChange(){
      this.getProducts()
    },
    getProducts(){
      request.post('biz/content/list',{page:this.currentPage-1,pageSize:this.pageSize,title:this.name,type:1,cateId:this.curCate})
      .then(res=>{
        console.log(res)
        this.proList=res.data.content
        this.total = res.data.total
      })
    },
    handleChangeCate(id){
      this.curCate=id
      this.getProducts()
    },
    getCataLog(){
      request.get('/system/category/getAll').then(res=>{
        const allCatelogs = res.data
        this.proCate = allCatelogs.filter(e=>e.type===1)
        if(this.curCate==null){
          this.curCate = this.proCate!=null && this.proCate.length>0 ? this.proCate[0].id : null
          this.getProducts()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .news {
    background: #fff;
  }
  .newsBanner {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
    margin-top: 2px;
  }
  .newsBanner img {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
  }
  .newsCenter {
    width: 1600px;
    margin: 0 auto;
  }
  .search {
    /* width: 321px; */
    height: 40px;
    margin-top: 51px;
    text-align: right;
  }
  .search input {
    width: 242px;
    height: 40px;
    border: 1px solid #ccc;
    border-right: none;
    padding-left: 5px;
    box-sizing: border-box;
    font-size: 14px;
    color: #666;
  }
  .search button {
    background: none;
    height: 40px;
    border: 1px solid #ccc;
  }

  /* 内容 */
  .newsTab .newsTab_top {
    border-bottom: 1px solid #ccc;
    margin-bottom: 50px;
  }
  .newsTab .newsTab_top ul {
    display: flex;
  }
  .newsTab_top ul li {
    width: 120px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    margin-right: 20px;
  }
  .new_active {
    color: #53CABE;
    border-bottom: 1px solid #53CABE;
  }

  .newsTab_center {
    width: 1600px;
    display: flex;
    flex-wrap: wrap;
  }
  .pro_item {
    width: 508px;
    height: 352px;
    background: #F7F8FB;
    margin-bottom: 38px;
    float: left;
    margin-right: 30px;
  }
  .pro_item:nth-child(3n){
    margin-right: 0;
  }

  .pro_item:hover {
    background: #53CABE;
  }
  .pro_item:hover .pro_detail {
    color: #fff;
  }

  .pro-img{
    width: 508px;
    height: 282px;
    overflow: hidden;
  }
.pro_item img {
    width: 508px;
    height: 282px;
    transition: all .5s;
    }
   .pro_item:hover.pro_item img{
      transform: scale(1.1);
    }
.pro_item .pro_detail {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.text_active {
  color: #fff !important;
}
.content_active {
  background: #53CABE !important;
}
.paginationMy{
    text-align: center;
    padding-bottom: 100px;
    padding-top: 82px;
}

@media (max-width: 1600px) {
        .newsTab_center,.newsCenter {
        width: 1200px;

    }
    .pro_item {
    width: 380px;
    height: 261px;
    background: #F7F8FB;
    margin-bottom: 38px;
  }
  .pro_item:hover {
    background: #53CABE;
    cursor: pointer;
  }
  .pro_item:hover .pro_detail {
    color: #fff;
  }

  .pro-img{
    width: 380px;
    height: 211px;
    overflow: hidden;
  }
.pro_item img {
  width: 380px;
    height: 211px;
    transition: all .5s;
    }
   .pro_item:hover.pro_item img{
      transform: scale(1.1);
    }

  }

</style>
